export const COLOR_TYPES = {
  red: '#f96666',
  orange: '#ff773c',
};
